import { SourceType } from './generated/api';

export const isVwfs = (source: string): source is SourceType => !!source?.startsWith('VWFS');

export const isUcs = (source: string): source is SourceType => source === SourceType.Ucs;
